const PHONE_REGEX = /^[()+0-9\s]+$/;
const NONDIGIT_REPLACE_REGEX = /[^0-9]+/g;

export function isValidPhone(val: string) {
    const digitLength = val.replace(NONDIGIT_REPLACE_REGEX, '').length;
    
    return val.length === 0 || (Boolean(val.match(PHONE_REGEX)) &&
        digitLength >= 10 && digitLength <= 18);
}